import { jsxs as r, jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M56.92 54H12c-1.1 0-2-.9-2-2V6L6 7.07V52c0 3.31 2.69 6 6 6h46l-1.08-4Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m31.26 12.53-4 1.07v35.6h4V12.53ZM43.14 23.01l-4 1.07V49.2h4V23.01ZM19.38 22.92l-4 1.07V49.2h4V22.92ZM55.02 33.25l-4 1.07V49.2h4V33.25Z"
        }
      )
    ]
  }
);
export {
  t as Usage
};
